export const typeIndivisual = (type) => {
    switch (type) {
        case 'leader-speak':
            return 'LeaderSpeak';
        case 'work-Anniversary':
            return 'WorkAniversary';
        case 'events':
            return 'Event';
        case 'awards':
            return 'Awards';
        case 'promotions':
            return 'Promotions';
        case 'birthdays':
            return 'Birthday';
        case 'birth-announcements':
            return 'birthAnnouncement';
        case 'social':
            return 'Social';
        case 'notice':
            return 'FeedAnnouncements'

        default:
            return 'FeedList'
    }
};
export const identifierType = () => ({
    dailyPost: "daily-post",
    workAniversary: "work-anniversaries",
    promotions: "promotions",
    comment: 'comment',
    postReact: 'post-reaction'
});